module.exports = __webpack_public_path__ + "img/trojka.d721baf2.svg";